import { create } from 'zustand';
import { getTripKey } from '../../utils/tripAnalysis';
import { 
    sendStatus,
    sendStatusBatch,
    sendDeleteStatus 
} from '../../channels/tripStatusAnalysisChannel';

function hasStatusData(payload) {
    return payload?.statusTrip != null;
}

export const useTripStatusAnalysisStore = create((set, get) => ({

    statusMap: new Map(),

    getStatus: (date, codigo) => {

        return get().statusMap.get(
            getTripKey(date, codigo)
        ) || null;

    },

    setStatus: (payload, broadcast = true) => {

        if (
            !payload?.date ||
            !payload?.codigo
        ) {
            return;
        }

        if (!hasStatusData(payload)) {
            return;
        }

        const statusMap = new Map(
            get().statusMap
        );

        statusMap.set(
            getTripKey(payload.date, payload.codigo),
            payload
        );

        set({
            statusMap
        });

        if (broadcast) {
            sendStatus(payload);
        }

    },

    setStatusBatch: (items = [], broadcast = true) => {

        if (items.length === 0) {
            return;
        }

        const statusMap = new Map(
            get().statusMap
        );

        for (const item of items) {

            if (
                !item?.date ||
                !item?.codigo
            ) {
                continue;
            }

            if (!hasStatusData(item)) {
                continue;
            }

            statusMap.set(
                getTripKey(item.date, item.codigo),
                item
            );

        }

        set({
            statusMap
        });

        if (broadcast) {
            sendStatusBatch(items);
        }

    },

    deleteStatus: (date, codigo, broadcast = true) => {

        const statusMap = new Map(
            get().statusMap
        );

        statusMap.delete(
            getTripKey(date, codigo)
        );

        set({
            statusMap
        });

        if(broadcast){
            sendDeleteStatus({date, codigo});
        }

    },

    exportStatus: () => {

        return [
            ...get().statusMap.values()
        ];

    },

    clearStatus: () => {

        set({
            statusMap: new Map()
        });

    }

}));